<template>
  <NavigationForm action="create" :pages="pages"/>
</template>

<script>
import NavigationForm from '@/components/Navigation/NavigationForm'
import Page from '@/model/Page'

export default {
  components: {
    NavigationForm
  },
  data () {
    return {
      pages: []
    }
  },
  beforeRouteEnter (to, from, next) {
    axios.all([
      Page.index({all_languages: true, allPages: true, order_by: 'title', sort_by: 'asc'})
    ]).then(axios.spread((pages) => {
      next(vm => {
        vm.pages = pages.data.data
      })
    }))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/navigation/Create.vue